import { ClipboardCheck } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../services/authentication/authContext';
import { canAccessSetupOverview } from '../../services/accessManagement/accessManagement';
import { useImpersonationStore } from '../../stores/appImpersonationStore';

export function SetupOverviewNavLink({ className, activeClassName = '', onClick, listItem = false }: {
  className: string; activeClassName?: string; onClick?: () => void; listItem?: boolean;
}) {
  const { t } = useTranslation();
  const { backendUser } = useAuth();
  const target = useImpersonationStore(state => state.target);
  if (!canAccessSetupOverview(backendUser, target?.userId ?? null)) return null;
  const link = <NavLink to="/setup-overview" onClick={onClick} className={({ isActive }) => `${className} ${isActive ? activeClassName : ''}`}>
    <ClipboardCheck className="w-6 h-6 shrink-0" aria-hidden="true" />
    {t('setupOverview.nav')}
  </NavLink>;
  return listItem ? <li>{link}</li> : link;
}
